import React from 'react';
import GraphicPreview from '../GraphicPreview';
import GraphicPreviewStack from '../GraphicPreviewStack';
import GraphicPreviewRivalry from '../GraphicPreviewRivalry';
import GraphicPreviewPoster from '../GraphicPreviewPoster';
import GraphicPreviewSplitScreen from '../GraphicPreviewSplitScreen';
import GraphicPreviewMinimal from '../GraphicPreviewMinimal';
import GraphicPreviewBold from '../GraphicPreviewBold';
import GraphicPreviewPhotoFrame from '../GraphicPreviewPhotoFrame';
import GraphicRecap from '../GraphicRecap';
import GraphicRecapFinalScore from '../GraphicRecapFinalScore';
import GraphicRecapVictory from '../GraphicRecapVictory';
import GraphicRecapHighlight from '../GraphicRecapHighlight';
import GraphicRecapClean from '../GraphicRecapClean';
import GraphicRecapSplitScreen from '../GraphicRecapSplitScreen';
import GraphicRecapMinimal from '../GraphicRecapMinimal';
import GraphicRecapBold from '../GraphicRecapBold';
import GraphicRecapPhotoFrame from '../GraphicRecapPhotoFrame';
import GraphicTryout from '../GraphicTryout';
import GraphicTryoutSplitScreen from '../GraphicTryoutSplitScreen';
import GraphicTryoutMinimal from '../GraphicTryoutMinimal';
import GraphicTryoutBold from '../GraphicTryoutBold';
import GraphicTryoutPhotoFrame from '../GraphicTryoutPhotoFrame';
import GraphicTryoutPoster from '../GraphicTryoutPoster';
import GraphicTryoutInfoCard from '../GraphicTryoutInfoCard';
import GraphicPlayerSpotlightShowcase from '../GraphicPlayerSpotlightShowcase';
import GraphicPlayerSpotlightFeature from '../GraphicPlayerSpotlightFeature';
import GraphicPlayerSpotlightCard from '../GraphicPlayerSpotlightCard';

function GraphicPreviewRenderer({
  templateType,
  template,
  formData,
  teamSport,
  teamColors,
  backgroundStyle,
  homeTeamLogo,
  awayTeamLogoPreview,
  isOrgTeam,
  graphicsLimitInfo,
  layoutSettings,
  dateFormat,
}) {
  const showWatermark =
    !isOrgTeam && graphicsLimitInfo?.subscriptionPlan === 'free';

  const canUseCutouts =
    isOrgTeam ||
    ['pro', 'premium', 'organization'].includes(
      graphicsLimitInfo?.subscriptionPlan
    );

  return (
    <>
      {/* GAME PREVIEW TEMPLATES */}
      {templateType === 'preview' && (
        <>
          {template === 'photoFrame' && (
            <GraphicPreviewPhotoFrame
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
            />
          )}
          {template === 'splitScreen' && (
            <GraphicPreviewSplitScreen
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
              dominantImage={formData.dominantImage}
              dominantImageScale={formData.dominantImageScale ?? 100}
              dominantImageX={formData.dominantImageX ?? 50}
              dominantImageY={formData.dominantImageY ?? 50}
              dominantImageOpacity={formData.dominantImageOpacity ?? 100}
            />
          )}
          {template === 'minimal' && (
            <GraphicPreviewMinimal
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
            />
          )}
          {template === 'bold' && (
            <GraphicPreviewBold
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
            />
          )}
          {template === 'classic' && (
            <GraphicPreview
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dominantImage={formData.dominantImage}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              dominantImageScale={formData.dominantImageScale ?? 100}
              dominantImageX={formData.dominantImageX ?? 50}
              dominantImageY={formData.dominantImageY ?? 50}
              dominantImageOpacity={formData.dominantImageOpacity ?? 100}
              detailTextColor={formData.detailTextColor || null}
              dateFormat={dateFormat}
            />
          )}
          {template === 'stack' && (
            <GraphicPreviewStack
              graphicData={formData}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dominantImage={formData.dominantImage}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              dominantImageScale={formData.dominantImageScale ?? 100}
              dominantImageX={formData.dominantImageX ?? 50}
              dominantImageY={formData.dominantImageY ?? 50}
              dominantImageOpacity={formData.dominantImageOpacity ?? 100}
              detailTextColor={formData.detailTextColor || null}
              dateFormat={dateFormat}
            />
          )}
          {template === 'rivalry' && (
            <GraphicPreviewRivalry
              graphicData={formData}
              teamColors={teamColors}
              teamSport={teamSport}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
              dateFormat={dateFormat}
            />
          )}
          {template === 'poster' && (
            <GraphicPreviewPoster
              graphicData={formData}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              teamSport={teamSport}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dominantImage={formData.dominantImage}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              dominantImageScale={formData.dominantImageScale ?? 100}
              dominantImageX={formData.dominantImageX ?? 0}
              dominantImageY={formData.dominantImageY ?? 100}
              dominantImageOpacity={formData.dominantImageOpacity ?? 100}
              detailTextColor={formData.detailTextColor || null}
              dateFormat={dateFormat}
            />
          )}
        </>
      )}

      {/* GAME RECAP TEMPLATES */}
      {templateType === 'recap' && (
        <>
          {template === 'photoFrame' && (
            <GraphicRecapPhotoFrame
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
            />
          )}
          {template === 'splitScreen' && (
            <GraphicRecapSplitScreen
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
            />
          )}
          {template === 'minimal' && (
            <GraphicRecapMinimal
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
            />
          )}
          {template === 'bold' && (
            <GraphicRecapBold
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
            />
          )}
          {template === 'classic' && (
            <GraphicRecap
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || 160}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
            />
          )}
          {template === 'finalScore' && (
            <GraphicRecapFinalScore
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dominantImage={formData.dominantImage}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              dominantImageScale={formData.dominantImageScale ?? 100}
              dominantImageX={formData.dominantImageX ?? 50}
              dominantImageY={formData.dominantImageY ?? 50}
              dominantImageOpacity={formData.dominantImageOpacity ?? 100}
              detailTextColor={formData.detailTextColor || null}
              dateFormat={dateFormat}
            />
          )}
          {template === 'victory' && (
            <GraphicRecapVictory
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dominantImage={formData.dominantImage}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              dominantImageScale={formData.dominantImageScale ?? 100}
              dominantImageX={formData.dominantImageX ?? 50}
              dominantImageY={formData.dominantImageY ?? 50}
              dominantImageOpacity={formData.dominantImageOpacity ?? 100}
              detailTextColor={formData.detailTextColor || null}
              dateFormat={dateFormat}
            />
          )}
          {template === 'highlight' && (
            <GraphicRecapHighlight
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              dominantImage={formData.dominantImage}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              dominantImageScale={formData.dominantImageScale ?? 100}
              dominantImageX={formData.dominantImageX ?? 50}
              dominantImageY={formData.dominantImageY ?? 50}
              dominantImageOpacity={formData.dominantImageOpacity ?? 100}
              detailTextColor={formData.detailTextColor || null}
              dateFormat={dateFormat}
            />
          )}
          {template === 'clean' && (
            <GraphicRecapClean
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              awayTeamLogoPreview={awayTeamLogoPreview}
              showWatermark={showWatermark}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || null}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
              dateFormat={dateFormat}
            />
          )}
        </>
      )}

      {/* TRYOUT TEMPLATES */}
      {templateType === 'tryout' && (
        <>
          {template === 'poster' && (
            <GraphicTryoutPoster
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || 160}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
            />
          )}
          {template === 'infoCard' && (
            <GraphicTryoutInfoCard
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || 160}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
            />
          )}
          {template === 'photoFrame' && (
            <GraphicTryoutPhotoFrame
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || 120}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
            />
          )}
          {template === 'splitScreen' && (
            <GraphicTryoutSplitScreen
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || 160}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
            />
          )}
          {template === 'minimal' && (
            <GraphicTryoutMinimal
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || 160}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
            />
          )}
          {template === 'bold' && (
            <GraphicTryoutBold
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || 160}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
            />
          )}
          {template === 'classic' && (
            <GraphicTryout
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              showWatermark={showWatermark}
              dateFormat={dateFormat}
              heroFont={formData.heroFont || 'Bebas Neue'}
              heroFontSize={formData.heroFontSize || 160}
              accentBlockColor={formData.accentBlockColor || null}
              detailTextColor={formData.detailTextColor || null}
            />
          )}
        </>
      )}

      {/* PLAYER SPOTLIGHT TEMPLATES */}
      {templateType === 'highlight' && (
        <>
          {template === 'showcase' && (
            <GraphicPlayerSpotlightShowcase
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              showWatermark={showWatermark}
              canUseCutouts={canUseCutouts}
            />
          )}
          {template === 'feature' && (
            <GraphicPlayerSpotlightFeature
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              showWatermark={showWatermark}
              canUseCutouts={canUseCutouts}
            />
          )}
          {template === 'card' && (
            <GraphicPlayerSpotlightCard
              graphicData={formData}
              teamSport={teamSport}
              teamColors={teamColors}
              backgroundStyle={backgroundStyle}
              homeTeamLogo={homeTeamLogo}
              showWatermark={showWatermark}
              canUseCutouts={canUseCutouts}
            />
          )}
        </>
      )}
    </>
  );
}

export default GraphicPreviewRenderer;
